import { useEffect, type RefObject } from 'react';

/**
 * Blurs a focused element inside the container when the page is restored from the back-forward cache,
 * so link buttons don't keep their focus/pressed styling after the user navigates Back.
 */
function useResetFocusOnBfcacheRestore(containerRef: RefObject<HTMLElement | null>) {
	useEffect(() => {
		const handlePageShow = (pageShowEvent: PageTransitionEvent) => {
			if (!pageShowEvent.persisted) {
				return;
			}

			const activeElement = document.activeElement;
			if (activeElement instanceof HTMLElement && containerRef.current?.contains(activeElement)) {
				activeElement.blur();
			}
		};

		window.addEventListener('pageshow', handlePageShow);

		return () => window.removeEventListener('pageshow', handlePageShow);
	}, [containerRef]);
}

export default useResetFocusOnBfcacheRestore;
